// Tugi Tark AI support-widget configuration.
//
// Every value here is PUBLIC and safe to ship to the browser — the JWT signing
// secret lives ONLY on the backend and is never exposed here. The brand ids are
// provided by Tugi Tark on signup and filled per build environment; until they
// are set the widget stays dormant via `enabled`, so this is inert on live until
// credentials + the flag are in place.
const isTrue = (value) => String(value).toLowerCase() === "true";

export const tugiConfig = {
  enabled: isTrue(process.env.REACT_APP_TUGI_ENABLED),
  // Load the widget for anonymous (not-logged-in) visitors too. Off by default:
  // GCC is real-money and the primary use case is authenticated player support.
  anonymous: isTrue(process.env.REACT_APP_TUGI_ANON),
  tenantId: process.env.REACT_APP_TUGI_TENANT_ID || "",
  brandId: process.env.REACT_APP_TUGI_BRAND_ID || "",
  brandName: process.env.REACT_APP_TUGI_BRAND_NAME || "",
  httpUrl: process.env.REACT_APP_TUGI_HTTP_URL || "https://app.tugi.ai/tugi.widget",
  wsUrl: process.env.REACT_APP_TUGI_WS_URL || "wss://ws.tugi.ai",
  scriptUrl:
    process.env.REACT_APP_TUGI_SCRIPT_URL || "https://app.tugi.ai/tugi.widget/script",
  // Backend endpoint (relative to config.apiUrl) that mints the signed player JWT.
  jwtEndpoint: process.env.REACT_APP_TUGI_JWT_ENDPOINT || "/tugi/widget-jwt",
};

// Brand ids must be present before the widget can connect to Tugi. Guards against
// a half-filled build accidentally initialising the widget with empty ids.
export function isTugiConfigured() {
  return Boolean(tugiConfig.tenantId && tugiConfig.brandId && tugiConfig.brandName);
}
